const supported = "closedBy" in HTMLDialogElement.prototype

if (!supported) addEventListener("toggle", dialogToggled, { capture: true })

function dialogToggled(event) {
  if (!event.target.matches("dialog[closedby=any]")) return
  const method = `${event.target.open ? "add" : "remove"}EventListener`
  event.target[method]("click", closeOnBackdropClick)
}

function closeOnBackdropClick(event) {
  if (event.target != event.currentTarget) return
  if (isBackdropClick(event)) event.target.close()
}

function isBackdropClick({ target, clientX, clientY }) {
  const { top, right, bottom, left } = target.getBoundingClientRect()
  return clientX < left || clientX > right || clientY < top || clientY > bottom
}
